import {
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from '@ionic/react';
import { RouterProps } from 'react-router';

import {
  walletOutline,
  // chatbubbleOutline,
  // logOutOutline,
} from 'ionicons/icons';

import { Redirect, Route } from 'react-router';
import React from 'react';

import Account from './Account';
import Messages from './Messages';
import {
  getUserAccount,
  Membership,
  AppError,
  logout,
} from '../lib/functionality';

const Home = ({ history }: RouterProps) => {
  const [membership, setMembership] = React.useState<Membership | undefined>();
  React.useEffect(() => {
    getUserAccount()
      .then(m => {
        setMembership(m);
      })
      .catch((err: AppError) => {
        if (err.code === 'AUTHERR') {
          history.replace('/login');
        }
      });
  }, [history]);

  const onUserLogout = async () => {
    await logout();
    history.replace('/login');
  };

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Redirect exact path="/home" to="/home/account" />
        <Route
          path="/home/account"
          exact={true}
          render={() => (
            <Account membership={membership} userLogout={onUserLogout} />
          )}></Route>
        <Route
          path="/home/messages"
          exact={true}
          render={() => <Messages />}></Route>
      </IonRouterOutlet>
      <IonTabBar slot="bottom">
        <IonTabButton tab="account" href="/home/account">
          <IonIcon icon={walletOutline} />
          <IonLabel>Membership</IonLabel>
        </IonTabButton>
        {/* <IonTabButton tab="messages" href="/home/messages">
          <IonIcon icon={chatbubbleOutline} />
          <IonLabel>Messages</IonLabel>
        /IonTabButton> */}
      </IonTabBar>
    </IonTabs>
  );
};

export default Home;
